module.exports = __webpack_public_path__ + "2c7b652f293e3cc10e54e825aaecd9c7.svg";